// Konfiguration der Teppichgrößen-Landingpages. Geteilt von React-Pages und
// scripts/prerender.js (lädt via vm-Shim, daher reines `export const`).
export const TEPPICH_SEITEN = [
  {
    slug: "teppichgroesse-esstisch",
    fall: "esstisch",
    keyword: "teppichgröße esstisch",
    title: "Teppichgröße Esstisch berechnen: welcher Teppich passt unter den Tisch",
    description:
      "Gib Tischlänge und -breite ein und sieh sofort die passende Teppichgröße, damit auch zurückgeschobene Stühle auf dem Teppich bleiben.",
    h1: "Welche Teppichgröße passt unter den Esstisch?",
    intro:
      "Ein Teppich unter dem Esstisch sollte so groß sein, dass die Stühle auch beim Zurückschieben mit allen Beinen auf dem Teppich stehen. Als Faustregel gilt rund 60 bis 80 cm Überstand pro Seite über die Tischkante hinaus. Gib deine Tischmaße ein und du bekommst die passende Größe und die nächste handelsübliche Standardgröße.",
    faq: [
      { q: "Wie groß muss der Teppich unter dem Esstisch sein?", a: "Rechne pro Seite etwa 60 bis 80 cm Überstand über die Tischkante hinaus. So bleiben die Stühle auch zurückgeschoben auf dem Teppich. Bei einem Tisch von 160 × 90 cm ergibt das etwa 290 × 220 cm, also eine Standardgröße von 240 × 340 cm." },
      { q: "Lieber etwas größer oder kleiner?", a: "Im Zweifel die größere Standardgröße wählen. Ein zu kleiner Teppich, von dem die Stühle kippen, wirkt unruhig und unpraktisch." },
    ],
  },
  {
    slug: "teppichgroesse-sofa",
    fall: "sofa",
    keyword: "teppichgröße sofa",
    title: "Teppichgröße Sofa: welcher Teppich passt vor die Couch",
    description:
      "Sofabreite eingeben und passende Teppichgröße berechnen, für die Variante mit vorderen Füßen auf dem Teppich oder komplett darauf.",
    h1: "Welche Teppichgröße passt vor das Sofa?",
    intro:
      "Vor dem Sofa gibt es zwei gängige Varianten. Entweder stehen nur die vorderen Sofafüße auf dem Teppich, das wirkt luftig, oder die ganze Sitzgruppe steht darauf. In beiden Fällen sollte der Teppich mindestens so breit wie das Sofa sein, idealerweise je Seite etwas darüber hinaus. Gib die Sofabreite ein und wähle die Variante.",
    faq: [
      { q: "Wie breit sollte der Teppich vor dem Sofa sein?", a: "Mindestens so breit wie das Sofa, ideal sind 20 bis 30 cm pro Seite mehr. Bei einem 220 cm breiten Sofa passt damit gut eine Größe um 200 × 290 cm quer." },
      { q: "Vordere Füße oder komplett auf dem Teppich?", a: "Beides ist korrekt. Nur die vorderen Füße auf dem Teppich wirkt offener und braucht weniger Fläche. Steht die ganze Sitzgruppe darauf, plane rundum etwa 50 bis 60 cm Rahmen ein." },
    ],
  },
  {
    slug: "teppichgroesse-ecksofa",
    fall: "sofa",
    keyword: "teppichgröße ecksofa",
    title: "Teppichgröße Ecksofa: passende Teppichgröße für die Eckcouch",
    description:
      "Teppichgröße für ein Ecksofa bestimmen. Breite eingeben und die passende Standardgröße sehen.",
    h1: "Welche Teppichgröße passt zum Ecksofa?",
    intro:
      "Beim Ecksofa orientiert sich der Teppich an der längeren Sofaseite und am offenen Bereich davor. Auch hier gilt: mindestens so breit wie die Sofafront, lieber etwas größer. Gib die Breite der längeren Seite ein. Steht die Ecke komplett auf dem Teppich, wähle die Variante komplett.",
    faq: [
      { q: "Wie groß sollte der Teppich beim Ecksofa sein?", a: "Miss die längere Sofaseite und plane mindestens diese Breite ein, ideal etwas mehr. Soll die ganze Ecke auf dem Teppich stehen, rechne rundum 50 bis 60 cm Rahmen." },
    ],
  },
  {
    slug: "teppichgroesse-wohnzimmer",
    fall: "wohnzimmer",
    keyword: "teppichgröße wohnzimmer",
    title: "Teppichgröße Wohnzimmer berechnen: passende Größe für den Raum",
    description:
      "Raummaße eingeben und die passende Teppichgröße fürs Wohnzimmer berechnen, mit genug Abstand zur Wand.",
    h1: "Welche Teppichgröße passt ins Wohnzimmer?",
    intro:
      "Liegt der Teppich frei im Raum, sollte rundum ein Streifen Boden sichtbar bleiben, etwa 30 bis 45 cm zur Wand. So wirkt der Raum ruhig und der Teppich nicht eingequetscht. Gib Raumlänge und -breite ein, du bekommst die größte sinnvolle Standardgröße, die diesen Abstand hält.",
    faq: [
      { q: "Wie viel Abstand zur Wand sollte der Teppich haben?", a: "Etwa 30 bis 45 cm rundum. Der Teppich sollte nie bündig bis zur Wand reichen, ein sichtbarer Bodenrand lässt den Raum größer wirken." },
      { q: "Welche Teppichgröße bei 4 × 5 m Wohnzimmer?", a: "Mit rund 40 cm Wandabstand bleibt eine Fläche von etwa 420 × 320 cm, dazu passt eine Standardgröße von 300 × 400 cm." },
    ],
  },
  {
    slug: "teppichgroesse-bett",
    fall: "bett",
    keyword: "teppichgröße bett",
    title: "Teppichgröße Bett: welcher Teppich passt ins Schlafzimmer",
    description:
      "Teppich unterm Bett richtig dimensionieren. Bettmaße eingeben und passende Größe sehen, für einen Teppich quer oder zwei Läufer.",
    h1: "Welche Teppichgröße passt unter das Bett?",
    intro:
      "Unter dem Bett gibt es zwei übliche Lösungen. Entweder liegt ein großer Teppich quer unter dem unteren Bettteil und ragt seitlich und am Fußende heraus, oder zwei Läufer liegen links und rechts vom Bett. Beim großen Teppich sind etwa 40 bis 60 cm Überstand sinnvoll. Gib die Bettmaße ein und wähle die Variante.",
    faq: [
      { q: "Wie weit sollte der Teppich unterm Bett herausragen?", a: "Seitlich und am Fußende etwa 40 bis 60 cm. So steht man morgens auf dem Teppich statt auf dem kalten Boden." },
      { q: "Ein großer Teppich oder zwei Läufer?", a: "Beides funktioniert. Ein großer Teppich quer unter dem unteren Bettteil wirkt großzügig, zwei Läufer sind die platzsparende und günstigere Variante." },
    ],
  },
];

export const TABELLE_SEITE = {
  slug: "teppich-groessentabelle",
  title: "Teppich Standardmaße: Größentabelle der gängigen Teppichgrößen",
  description:
    "Übersicht der handelsüblichen Teppichgrößen in cm, rechteckig und rund, mit Empfehlung für Esstisch, Sofa, Wohnzimmer und Bett.",
  h1: "Teppich Standardmaße und Größentabelle",
  faq: [
    { q: "Welche Teppichgrößen sind Standard?", a: "Im Handel verbreitet sind rechteckig unter anderem 60 × 120, 80 × 150, 120 × 170, 140 × 200, 160 × 230, 170 × 240, 200 × 290, 240 × 340 und 300 × 400 cm. Rund gängig sind Durchmesser von 120, 160, 200 und 250 cm." },
    { q: "Welche Teppichgröße ist die beliebteste fürs Wohnzimmer?", a: "Häufig gewählt werden 170 × 240 cm und 200 × 290 cm. Welche passt, hängt von Raumgröße und Möbeln ab. Der Rechner gibt dir für deinen Fall eine konkrete Empfehlung." },
  ],
};

export const HUB_SEITE = {
  slug: "teppichgroesse",
  title: "Teppichgröße berechnen: welcher Teppich passt | Rechner",
  description:
    "Kostenloser Rechner für die passende Teppichgröße bei Esstisch, Sofa, Wohnzimmer und Bett. Maße eingeben, Empfehlung und Standardgröße sehen.",
  h1: "Welche Teppichgröße passt?",
};
